module.exports = __webpack_public_path__ + "media/images/web_suite/feature_icons/icon_checklist-ed526f34678a5631ed305fa235c86706.png";